import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../models/GroupsState";
import { SetSelectedServicePayload } from "../payload/SetSelectedServicePayload";

const setSelectedService = (state: GroupsState, action: PayloadAction<SetSelectedServicePayload>) => {
    const { service } = action.payload;
    state.selectedService = service;
}

export default setSelectedService;